module.exports = __webpack_public_path__ + "img/HM.b28b7abb.png";